import { Validators } from '@angular/forms';

export const createUserControlsConfig = {
    token: ['', Validators.required],
    name: ['', Validators.required],
    password: ['', Validators.required]
};
